<template>
  <WBDDictionarySelectorFilter
    discr="office_type"
    :remote-list="remoteList"
    :selected-option-value="selectedOptionValue"
    label="Поиск типов объекта (от 2-х букв)"
    :on-change-event="onChangeEvent"
    hideSearchIcon
    loadOnStart
    :on-reset-event="resetEvent"
    @onOfficeTypeSelectorFilterChange="onOfficeTypeSelectorFilterChange"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import DictionaryMixin from '@/mixins/dictionaryMixin'
import WBDDictionarySelectorFilter from '@/components/common/filter/dictionary-selector-filter'

export default {
  name: 'WBDOfficeTypeSelectorFilter',
  components: {
    WBDDictionarySelectorFilter,
  },
  mixins: [DictionaryMixin],
  props: {
    remoteOptionValue: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
  },
  data () {
    return {
      resetEvent: null,
      onChangeEvent: 'onOfficeTypeSelectorFilterChange',
      loading: false,
      searchQuery: null,
      selectedOptionValue: null,
    }
  },
  computed: {
    ...mapGetters({
    }),
  },
  created () {
    if (this.remoteOptionValue) {
      this.selectedOptionValue = this.remoteOptionValue
    }
    this.resetEvent = this.eventNames.OFFICE_TYPE_LIST_FILTER_RESET

    this.eventsBus.$on(this.resetEvent, () => {
      this.selectedOptionValue = null
      this.searchQuery = null
    })
  },
  methods: {
    onOfficeTypeSelectorFilterChange (data) {
      this.$emit(
        this.onChangeEvent,
        data
      )
    },
  }
}
</script>
